import Api from '@/providers/Api';

export const SET_MEMBERSHIP_TYPES_MUTATION = 'SET_MEMBERSHIP_TYPES_MUTATION';
export const GET_MEMBERSHIP_TYPES_ACTION = 'GET_MEMBERSHIP_TYPES_ACTION';

export default {
  state: () => ({
    items: [],
  }),
  getters: {
    getMembershipTypesSupportedFields: (state) => (itemId) => {
      const memberType = state.items.find(({ id }) => id === itemId);
      if (!memberType || !memberType.supported_fields) return [];
      try {
        return JSON.parse(memberType.supported_fields);
      } catch {
        return [];
      }
    },
    getMembershipTypeName: (state) => (itemId) => {
      const memberType = state.items.find(({ id }) => id === itemId);
      return memberType && memberType.type_name ? memberType.type_name : null;
    },
  },
  mutations: {
    [SET_MEMBERSHIP_TYPES_MUTATION]: function (state, types) {
      state.items = types;
    },
  },
  actions: {
    [GET_MEMBERSHIP_TYPES_ACTION]: async function ({ commit }) {
      const response = await Api.getSocietyMembershipTypes();
      commit(SET_MEMBERSHIP_TYPES_MUTATION, response.items);
    },
  },
};
